var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.totalPages > 1)?_c('div',{staticClass:"page-wrapper"},_vm._l((_vm.visiblePages),function(item,index){return _c('PaginatorItem',{key:index,attrs:{"page":item,"lastPage":_vm.totalPages,"active":_vm.page === item},on:{"change":function($event){return _vm.$emit('change', $event)}}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }